// extracted by mini-css-extract-plugin
export var actionButton = "_qf-0";
export var actionMenuContainer = "_qf-i";
export var bubble = "_qf-2";
export var bubbleActionMenu = "_qf-j";
export var bubbleContext = "_qf-6";
export var bubbleItems = "_qf-7";
export var customer = "_qf-3";
export var divider = "_qf-8";
export var fileList = "_qf-9";
export var hiddenComment = "_qf-o";
export var infoAbove = "_qf-a";
export var internal = "_qf-4";
export var lightActionButton = "_qf-1";
export var link = "_qf-b";
export var merchant = "_qf-5";
export var message = "_qf-c";
export var profilePicture = "_qf-e";
export var quillToolbarContainer = "_qf-f";
export var senderDate = "_qf-g";
export var senderDateCustomer = "_qf-h";
export var senderName = "_qf-d";
export var time = "_qf-k";
export var uploadedImage = "_qf-l";
export var username = "_qf-m";
export var xsmall = "_qf-n";